module.exports = __webpack_public_path__ + "img/alberta-innovates.1811b50a.png";